export default __webpack_public_path__ + "static/media/POSSIBLE_CONSIDERATION.e263b881.png";